import clsx from "clsx";
import type { HistoryMode } from "@/features/history/historyMode";

interface HistoryModeToggleProps {
  mode: HistoryMode;
  onChange: (mode: HistoryMode) => void;
  className?: string;
}

/** 閲覧履歴と書込履歴を同じ表示領域で切り替える。 */
export function HistoryModeToggle({
  mode,
  onChange,
  className,
}: HistoryModeToggleProps): React.ReactElement {
  return (
    <fieldset className={clsx("history-mode-toggle", className)}>
      <legend className="sr-only">表示する履歴</legend>
      <button
        type="button"
        aria-pressed={mode === "viewed"}
        onClick={(): void => onChange("viewed")}
      >
        閲覧履歴
      </button>
      <button
        type="button"
        aria-pressed={mode === "posted"}
        onClick={(): void => onChange("posted")}
      >
        書込履歴
      </button>
    </fieldset>
  );
}
